var plugin_rtlignore_default = {
  "alignLeft": "ddZeB",
  "textWrapNowrap": "teJ86",
  "alignRight": "kJYND",
  "alignCenter": "Hjm3h",
  "sizeFullWidth": "rgefL",
  "renderedInTable": "LgPWG",
  "sizeOriginal": "e5-W6",
  "sizeContent": "dR0Zr",
  "sizeSmall": "UE4rP",
  "sizeSmallCenter": "EK9SF",
  "flex": "Hv29g",
  "atomic": "_8N97g",
  "embed": "_10DMj",
  "horizontalScrollbar": "rDDwk",
  "pluginContainerMobile": "yrfN0"
};
export {
  plugin_rtlignore_default as default
};
//# sourceMappingURL=plugin.rtlignore-scss.js.map
